export default () => {
  const formatCurrency = (value: number, showCents: boolean = true): string => {
    const currency = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: showCents ? 2 : 0,
      maximumFractionDigits: showCents ? 2 : 0,
    });

    return currency.format(value);
  };

  return { formatCurrency };
};
